import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const authGuard = (to, from, next) => {
  if (store.state.isLoggedIn) {
    return next();
  }
  next('/login');
}

const notAuthGuard = (to, from, next) => {
  if (!store.state.isLoggedIn) {
    return next();
  }
  next('/');
}

const routes = [
  {
    path: '/',
    component: Home,
    beforeEnter: authGuard
  },
  {
    path: '/login',
    component: Login,
    beforeEnter: notAuthGuard
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
